// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";

// Sub-Components

// Data / Images / Icons

function HelloWorld() {
  return (
    <DefaultLayout>
      <div className="text-white">Hello World</div>
    </DefaultLayout>
  );
}

export default HelloWorld;
